$(function () {
    $(".show-children").click(function (e) {
        var submenuID = e.currentTarget.dataset.id;

        var $parent = $(this).parent();
        // Reset expand arrow icon
        $parent.removeClass("expanded");

        // Collapse other submenus when opening new one
        if ($("." + submenuID).css("display") === "none") {
            $(".submenu-dropdown").css({
                "display": "none"
            });
            $parent.addClass("expanded");
            $(this).attr("aria-expanded", "true");
            $("." + submenuID).toggle("fast");
        } else {
            $("." + submenuID).toggle("fast");
            $(this).attr("aria-expanded", "false");
        }
    });

    // Close menu when clicking outside
    $(document).click(function (e) {
        var $target = $(e.target);
        if (!$target.closest(".show-children").length && !$target.closest(".submenu-dropdown").length) {
            $(".submenu-dropdown").hide("fast");
            $(".show-children").attr("aria-expanded", "false");
            $(".expanded").removeClass("expanded");
        }
    });

    $(".submenu-dropdown li:last-child a").on("keydown", function (e) {
        if (e.keyCode === 9) { // Tab key
            $(".submenu-dropdown").hide("fast");
            $(".show-children").attr("aria-expanded", "false");
            $(".expanded").removeClass("expanded");
        }
    });
});